import React from 'react';
import { SessionStore } from '../../stores';

const storesContext = React.createContext({
  sessionStore: SessionStore(),
});

export default storesContext;
